var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"mb-2 font-weight-bold"},[(item.show)?[_c('span',{domProps:{"innerHTML":_vm._s(item.title)}}),(item.br)?_c('br'):_vm._e(),_c('span',{staticClass:"text-pre-wrap font-weight-regular",domProps:{"innerHTML":_vm._s(item.value)}})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }